var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:['warning text-center', _vm.customClass],attrs:{"id":"notice"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }